import { useState } from 'react';

const faqs = [
  {
    question: '黄油相机是免费的吗？',
    answer: '黄油相机提供免费版本，包含大部分基础功能如文字添加、常用滤镜和基础模板。同时也有会员版本，解锁全部字体、高级滤镜、专属模板和无损导出等高级功能。免费版已经可以满足大部分日常修图需求。',
  },
  {
    question: '黄油相机支持哪些设备？',
    answer: '黄油相机目前支持iOS和Android两大平台。iOS版本要求iOS 13.0及以上系统，支持iPhone和iPad设备。Android版本要求Android 6.0及以上系统，兼容市面上绝大多数安卓手机品牌，包括华为、小米、OPPO、vivo、三星等。',
  },
  {
    question: '如何确保下载的是正版黄油相机？',
    answer: '为确保下载正版黄油相机，请通过以下官方渠道下载：iOS用户请在Apple App Store搜索"黄油相机"；Android用户请在手机自带的应用商店（如华为应用市场、小米应用商店等）搜索"黄油相机"，认准开发者为"北京缪客科技有限公司"。本站提供的下载链接均指向官方渠道。',
  },
  {
    question: '黄油相机的水印可以去掉吗？',
    answer: '可以的。黄油相机免费版导出的照片底部会有黄油相机的品牌水印。如果您希望导出无水印的照片，可以升级为黄油相机会员，会员支持无损画质导出且无水印。黄油相机8.0版本还新增了智能去水印功能。',
  },
  {
    question: '黄油相机的数据会丢失吗？',
    answer: '黄油相机支持账号登录和云端同步功能。建议您注册并登录黄油相机账号，这样您的模板收藏、历史作品和会员权益都会与账号绑定。即使更换手机或重装App，只要登录同一账号即可恢复所有数据。',
  },
  {
    question: '黄油相机8.0版本有哪些新功能？',
    answer: '黄油相机8.0版本是今年最重要的一次更新，主要新增功能包括：AI智能排版引擎（自动识别照片内容推荐最佳排版方案）、一键去水印功能、批量处理功能（一次性对多张照片应用相同效果）、新增20款字体和15款滤镜、以及全面的性能优化，图片加载速度提升30%。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            常见问题解答
          </h2>
          <p className="text-sm text-foreground-500">关于黄油相机的下载与使用，这里有你想要的答案</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm text-foreground-400 mb-3">还有其他问题？</p>
          <Link to="/category/changjian-wenti" className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 cursor-pointer">
            查看更多常见问题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}